// 层次聚类热图
import ChartTemplate from '../ChartTemplate';
import { userFileRead } from '@/plugins/api';

let
  xs = [],  // x轴刻度内容
  ys = [],  // y轴刻度内容
  mt = 0, // top层次高度
  ml = 0, // left层次宽度
  scaleT = 10,// 上边层次线高放大倍数
  scaleL = 10, // 左侧层次线宽放大倍数
  topClusterStr,  // top 层次聚类字符
  leftClusterStr, // left 层次聚类字符
  ch = 25, // 初始化格子高度,跟右侧的字体大小有关，如果右侧的字体偏大，则这里的值需要做相应调整
  bh = 100,//  底部颜色标尺及刻度高度
  fullHeight = 0, // 默认总高度
  ms = 0,   // 留白大小
  leftTree = true, // 是否绘制左侧树
  topTree = true, // 是否绘制顶部树
  leftG = null,
  topG = null,
  topMax = 200, leftMax = 200 // 树杈最高高度,  树杈最宽宽度
  ;

export default {
  extends: ChartTemplate,
  props: {
    config: {
      default: function () { return {} }
    }
  },
  methods: {
    resetVars () {
      xs = [];  // x轴刻度内容
      ys = [];  // y轴刻度内容
      mt = 0; // top层次高度
      ml = 0; // left层次宽度
      scaleT = 10;// 上边层次线高放大倍数
      scaleL = 10; // 左侧层次线宽放大倍数
      topClusterStr = null;  // top 层次聚类字符
      leftClusterStr = null; // left 层次聚类字符
      ch = 25; // 初始化格子高度,跟右侧的字体大小有关，如果右侧的字体偏大，则这里的值需要做相应调整
      bh = 100;//  底部颜色标尺及刻度高度
      fullHeight = 0; // 默认总高度
      ms = 0;   // 留白大小
      leftTree = true; // 是否绘制左侧树
      topTree = true; // 是否绘制顶部树
      leftG = null;
      topG = null;
      topMax = 200;
      leftMax = 200; // 树杈最高高度,  树杈最宽宽度
    },
    async initDataAfter () {
      this.resetVars();
      let dto1 = this.Utility.clone(this.dataSourceParam);
      dto1.parse = false;
      if (this.embed) dto1.path = this.config.topTree;
      else dto1.toolTask.resultFile = 'tree_top.txt';
      await userFileRead(dto1).then(res => topClusterStr = res.data)
      let dto2 = this.Utility.clone(this.dataSourceParam);
      dto2.parse = false;
      if (this.embed) dto2.path = this.config.leftTree;
      else dto2.toolTask.resultFile = 'tree_left.txt';
      await userFileRead(dto2).then(res => leftClusterStr = res.data)
    },
    initParamAfter () { // 初始化left, top参数
      leftTree = this.paramFormData.clusterLeftTree;
      topTree = this.paramFormData.clusterTopTree;
    },
    initOptionAfter () {
      if (topTree) {
        this.processTopTree();
        mt = this.calcMargin(topClusterStr);
      }
      if (leftTree) {
        this.processLeftTree();
        ml = this.calcMargin(leftClusterStr);
      }

      xs = this.chartOption.xAxis.categories;
      ys = this.chartOption.yAxis.categories;
      if (ys.length > 1000) ch = 1;
      let height = ch * ys.length + mt + bh;
      fullHeight = height;
      let option = {
        chart: {
          marginTop: topTree ? (mt * scaleT + ms) : ms,
          marginLeft: leftTree ? (ml * scaleL + ms) : ms,
          height: topTree ? height : (height - mt)
        },
        yAxis: { opposite: true, reversed: true, labels: { style: { fontSize: parseInt(ch / 1.5) + 'px' } } },
      }
      this.Utility.deepMerge(this.chartOption, option);
    },
    initChartAfter () {
      leftG = this.chart.renderer.g().attr({ id: `${this.chartElId}_left_cluster` }).add();
      if (leftTree) this.drawLeftCluster(leftClusterStr, leftG);
      topG = this.chart.renderer.g().attr({ id: `${this.chartElId}_top_cluster` }).add();
      if (topTree) this.drawTopCluster(topClusterStr, topG);
    },
    onParamFormChangedBefore (e, item) {
      if (item.code == 'clusterLeftTree') {
        let el = document.getElementById(`${this.chartElId}_left_cluster`);
        if (el) {
          el.remove();
          leftG = null;
        }
        leftTree = e;
        let option = { chart: { marginLeft: e ? (ml * scaleL + ms) : ms } }
        this.chart.update(option);
        if (e) {
          leftG = this.chart.renderer.g().attr({ id: `${this.chartElId}_left_cluster` }).add();
          this.drawLeftCluster(leftClusterStr, leftG);
        }
        // 需要重新绘制topTree
        if (topTree) {
          let el = document.getElementById(`${this.chartElId}_top_cluster`);
          if (el) {
            el.remove();
            topG = null;
          }
          topG = this.chart.renderer.g().attr({ id: `${this.chartElId}_top_cluster` }).add();
          this.drawTopCluster(topClusterStr, topG);
        }
        return false;
      }
      if (item.code == 'clusterTopTree') {
        let el = document.getElementById(`${this.chartElId}_top_cluster`);
        if (el) {
          el.remove();
          topG = null;
        }
        topTree = e;
        let option = { chart: { marginTop: e ? (mt * scaleT + ms) : ms, height: e ? fullHeight : (fullHeight - mt) } }
        this.chart.update(option);
        if (e) {
          topG = this.chart.renderer.g().attr({ id: `${this.chartElId}_top_cluster` }).add();
          this.drawTopCluster(topClusterStr, topG);
        }
        // 需要重新绘制leftTree
        if (leftTree) {
          let el = document.getElementById(`${this.chartElId}_left_cluster`);
          if (el) {
            el.remove();
            leftG = null;
          }
          leftG = this.chart.renderer.g().attr({ id: `${this.chartElId}_left_cluster` }).add();
          this.drawLeftCluster(leftClusterStr, leftG);
        }
        return false;
      }
    },

    // =========== 画顶部聚类树
    drawTopCluster (str, g) {
      let sgp = this.chart.container.getElementsByClassName('highcharts-series-group');
      let w = sgp[0].getBBox().width / xs.length; // 单个格子宽度
      let mat = str.match(/[(]{1}[^()]+[)]{1}/g);
      if (!mat || mat.length == 0) return;
      for (let i = 0, l = mat.length; i < l; i++) {
        let gstr = mat[i]; // (a:2,b:3,c:3)
        let ge = gstr.substring(1, gstr.length - 1); // a:2,b:3,c:3
        let gs = ge.split(',');
        let xmin, xmax, hmax;
        for (let m = 0, n = gs.length - 1; m < n; m++) {
          let lstr = gs[m].trim(), rstr = gs[m + 1].trim();
          let ls = lstr.split(':'), rs = rstr.split(':');
          let lt = ls[0], lv = Number(ls[1]), rt = rs[0], rv = Number(rs[1]); // a,2,b,3
          let xl = w / 2 + w * xs.indexOf(lt), hl = 0; // 左边连线的x坐标，左边连线的高度
          if (lt.charAt(0) == '_') {
            let lts = lt.split('_');
            xl = Number(lts[1]);
            hl = Number(lts[2]);
          }
          let xr = w / 2 + w * xs.indexOf(rt), hr = 0; // 右边连线的x坐标，右边连线的高度
          if (rt.charAt(0) == '_') {
            let rts = rt.split('_'); // _x_y
            xr = Number(rts[1]);
            hr = Number(rts[2]);
          }
          let
            y1 = (mt - hl) * scaleT + ms,
            y2 = (mt - hl - lv) * scaleT + ms,
            y3 = (mt - hr - rv) * scaleT + ms,
            y4 = (mt - hr) * scaleT + ms;

          let xll = leftTree ? (ml * scaleL + ms) : ms;
          let path = [
            'M',
            xl + xll, y1,
            'L',
            xl + xll, y2 > y3 ? y2 : y3,
            xr + xll, y2 > y3 ? y2 : y3,
            xr + xll, y4
          ];
          this.chart.renderer.path(path).attr({ 'stroke-width': 1, stroke: '#000000', zIndex: 20 }).add(g);
          let txmin = xl < xr ? xl : xr, txmax = xl > xr ? xl : xr;
          xmin = !xmin ? txmin : txmin < xmin ? txmin : xmin;
          xmax = !xmax ? txmax : txmax > xmax ? txmax : xmax;
          let htl = lv + hl, htr = rv + hr;
          hmax = htl > htr ? htl : htr;
        }
        str = str.replace(mat[i], '_' + (xmin + (xmax - xmin) / 2) + '_' + hmax);
      }
      this.drawTopCluster(str, g);
    },
    // ================ 画左侧聚类树
    drawLeftCluster (str, g) {
      let sgp = this.chart.container.getElementsByClassName('highcharts-series-group');
      let h = sgp[0].getBBox().height / ys.length; // 单个格子高度
      let mat = str.match(/[(]{1}[^()]+[)]{1}/g);
      if (!mat || mat.length == 0) return;
      for (let i = 0, l = mat.length; i < l; i++) {
        let gstr = mat[i]; // (a:2,b:3,c:3)
        let ge = gstr.substring(1, gstr.length - 1); // a:2,b:3,c:3
        let gs = ge.split(',');
        let ymin, ymax, wmax;
        for (let m = 0, n = gs.length - 1; m < n; m++) {
          let lstr = gs[m].trim(), rstr = gs[m + 1].trim();
          let ls = lstr.split(':'), rs = rstr.split(':');
          let lt = ls[0], lv = Number(ls[1]), rt = rs[0], rv = Number(rs[1]); // a,2,b,3
          let yu = h / 2 + h * ys.indexOf(lt), wu = 0; // 上边连线的y坐标，上边连线的宽度
          if (lt.charAt(0) == '_') {
            let lts = lt.split('_');
            yu = Number(lts[1]);
            wu = Number(lts[2]);
          }
          let yd = h / 2 + h * ys.indexOf(rt), wd = 0; // 下边连线的y坐标，下边连线的宽度
          if (rt.charAt(0) == '_') {
            let rts = rt.split('_'); // _x_y
            yd = Number(rts[1]);
            wd = Number(rts[2]);
          }
          let
            x1 = (ml - wu) * scaleL + ms,
            x2 = (ml - wu - lv) * scaleL + ms,
            x3 = (ml - wd - rv) * scaleL + ms,
            x4 = (ml - wd) * scaleL + ms;
          let mtt = topTree ? (mt * scaleT + ms) : ms;
          let path = [
            'M',
            x1, yu + mtt,
            'L',
            x2 > x3 ? x2 : x3, yu + mtt,
            x2 > x3 ? x2 : x3, yd + mtt,
            x4, yd + mtt
          ];
          this.chart.renderer.path(path).attr({ 'stroke-width': 1, stroke: '#000000', zIndex: 20 }).add(g);

          let tymin = yu < yd ? yu : yd, tymax = yu > yd ? yu : yd;
          ymin = !ymin ? tymin : tymin < ymin ? tymin : ymin;
          ymax = !ymax ? tymax : tymax > ymax ? tymax : ymax;
          let wtu = lv + wu, wtd = rv + wd;
          wmax = wtu > wtd ? wtu : wtd;
        }
        str = str.replace(mat[i], '_' + (ymin + (ymax - ymin) / 2) + '_' + wmax);
      }
      this.drawLeftCluster(str, g);
    },

    // =============== 计算聚类字符串所需空间[高度或宽度]
    calcMargin (clusterStr) {
      let ret = 0;
      let calc = (str) => {
        let mat = str.match(/[(]{1}[^()]+[)]{1}/g);
        if (!mat || mat.length == 0) {
          ret = Number(str.split('_')[1]);
          return;
        }
        for (let i = 0, l = mat.length; i < l; i++) {
          let gstr = mat[i]; // (a:2,b:2)
          let g = gstr.substring(1, gstr.length - 1); // a:2,b:2
          let gs = g.split(','); // [a:2, b:2]
          let gl = gs[0], gr = gs[1]; // a:2   b:2
          let gls = gl.split(':'), grs = gr.split(':'); // [a,2]  [b,2]
          let gls0 = gls[0], gls1 = Number(gls[1]), grs0 = grs[0], grs1 = Number(grs[1]);
          let lmv = gls1, rmv = grs1;
          if (gls0.charAt(0) == '_') {
            let gls0s = gls0.split('_');
            lmv = Number(gls0s[2]) + gls1;
          }
          if (grs0.charAt(0) == '_') {
            let grs0s = grs0.split('_');
            rmv = Number(grs0s[2]) + grs1;
          }
          str = str.replace(mat[i], '_' + lmv + '_' + rmv);
        }
        calc(str);
      }
      calc(clusterStr);
      return ret;
    },
    processTopTree () {
      let mat = topClusterStr.match(/:[+-]?[\d]+([.][\d]+)?([Ee][+-]?[\d]+)?/g);
      let max = 0;
      mat.forEach(m => {
        let v = Number(m.substr(1));
        if (v > max) max = v;
      })
      if (max > topMax) {
        scaleT = 1;
        let scale = max / topMax;
        for (let i = 0, l = mat.length; i < l; i++) {
          let v = parseFloat(mat[i].substr(1)).toFixed(4);
          topClusterStr = topClusterStr.replace(mat[i], ':' + parseFloat(v / scale).toFixed(4));
        }
      }
    },
    processLeftTree () {
      let mat = leftClusterStr.match(/:[+-]?[\d]+([.][\d]+)?([Ee][+-]?[\d]+)?/g);
      let max = 0;
      mat.forEach(m => {
        let v = Number(m.substr(1));
        if (v > max) max = v;
      })
      if (max > leftMax) {
        scaleL = 1;
        let scale = max / leftMax;
        for (let i = 0, l = mat.length; i < l; i++) {
          let v = parseFloat(mat[i].substr(1)).toFixed(4);
          leftClusterStr = leftClusterStr.replace(mat[i], ':' + parseFloat(v / scale).toFixed(4));
        }
      }
    }


  }
}